import {
	type Chat,
	isHumanMessage,
} from '@atlassian/conversation-assistant-service-api/types/assistance-service';

// A turn saves its user message before its IN_PROGRESS reply row, so a history that is empty or
// ends on a human message may belong to a turn whose rows have not landed yet.
export const isAwaitingReply = (latestMessages: Chat): boolean => {
	const lastMessage = latestMessages.at(-1);
	return lastMessage === undefined || isHumanMessage(lastMessage);
};
